import styled, { css } from 'styled-components';

export const Li = styled.li`
  &:hover,
  &.active {
    &:after {
      transform: scaleX(1);
    }
  }
`;
export const Overlay = styled.div`
  background: black;
  height: 100%;
  left: 0;
  opacity: 0.3;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 99;
`;

export const Integrations = styled.section`
  align-items: flex-start;
  display: flex;
  justify-content: space-between;
  margin-bottom: 100px;
  margin-top: 50px;
  ${({ theme }) => {
    return (
      theme &&
      css`
        @media (max-width: ${theme.breakpoints.medium}) {
          flex-direction: column;
          margin-bottom: 45px;
          margin-top: 0;
        }
      `
    );
  }}
  .list_categories {
    align-items: flex-start;
    display: flex;
    flex-direction: column;
    font-size: 14px;
    font-weight: 600;
    justify-content: flex-start;
    width: 20%;
    ${({ theme }) => {
      return (
        theme &&
        css`
          @media (max-width: ${theme.breakpoints.medium}) {
            width: 100%;
            flex-direction: row;
            justify-content: center;
            flex-wrap: wrap;
          }
        `
      );
    }}
    li {
      cursor: pointer;
      display: block;
      margin-top: 20px;
      position: relative;
      ${({ theme }) => {
        return (
          theme &&
          css`
            @media (max-width: ${theme.breakpoints.medium}) {
              margin-left: 5px;
              margin-right: 5px;
            }
          `
        );
      }}
      &::after {
        background: #364ef7;
        bottom: -4px;
        content: '';
        height: 2px;
        left: 0;
        position: absolute;
        transform: scaleX(0);
        transition: 300ms;
        width: 100%;
      }
    }
  }
`;

export const ListCategories = styled.ul`
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  font-size: 14px;
  font-weight: 600;
  justify-content: flex-start;
  width: 20%;
  ${({ theme }) => {
    return (
      theme &&
      css`
        @media (max-width: ${theme.breakpoints.medium}) {
          width: 100%;
          flex-direction: row;
          justify-content: center;
          flex-wrap: wrap;
        }
      `
    );
  }}
  li {
    cursor: pointer;
    display: block;
    margin-top: 20px;
    position: relative;
    ${({ theme }) => {
      return (
        theme &&
        css`
          @media (max-width: ${theme.breakpoints.medium}) {
            margin-left: 5px;
            margin-right: 5px;
          }
        `
      );
    }}
    &::after {
      background: #364ef7;
      bottom: -4px;
      content: '';
      height: 2px;
      left: 0;
      position: absolute;
      transform: scaleX(0);
      transition: 300ms;
      width: 100%;
    }
  }
`;

export const ListIntegrations = styled.ul`
  align-items: flex-start;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-start;
  margin: -10px;
  width: calc(80% - 20px);
  ${({ theme }) => {
    return (
      theme &&
      css`
        @media (max-width: ${theme.breakpoints.medium}) {
          width: calc(100% + 10px);
          margin: -5px;
          margin-top: 20px;
        }
      `
    );
  }}
  li {
    background: #e9ebed;
    border: 1px solid #e9ebed;
    border-radius: 15px;
    box-sizing: border-box;
    cursor: pointer;
    height: 0;
    margin: 10px;
    overflow: hidden;
    padding-bottom: 15%;
    position: relative;
    transition: all 0.3s ease-in-out;
    width: calc(25% - 20px);
    > div {
      position: static !important;
    }
    ${({ theme }) => {
      return (
        theme &&
        css`
          @media (max-width: ${theme.breakpoints.medium}) {
            width: calc(50% - 10px);
            margin: 5px;
            padding-bottom: 30%;
          }
        `
      );
    }}
    &:hover {
      border-color: #364ef7;
      h5 {
        opacity: 1;
      }
    }
    img {
      bottom: auto !important;
      height: 50% !important;
      left: 10% !important;
      min-height: auto !important;
      min-width: auto !important;
      mix-blend-mode: darken;
      object-fit: contain;
      position: absolute;
      right: auto !important;
      top: 25% !important;
      transform: translateZ(0);
      width: 80% !important;
      ${({ theme }) => {
        return (
          theme &&
          css`
            @media (max-width: ${theme.breakpoints.medium}) {
              top: 15% !important;
            }
          `
        );
      }}
    }
    h5 {
      align-items: flex-end;
      background: #00000011;
      box-sizing: border-box;
      color: black;
      display: flex;
      font-size: 14px;
      font-weight: 600;
      height: 100%;
      justify-content: center;
      left: 0;
      line-height: 16px;
      opacity: 0;
      padding: 10px;
      position: absolute;
      text-align: center;
      top: 0;
      transition: 0.3s;
      width: 100%;
      ${({ theme }) => {
        return (
          theme &&
          css`
            @media (max-width: ${theme.breakpoints.medium}) {
              opacity: 1;
              background: transparent;
            }
          `
        );
      }}
    }
  }
`;

export const Banners = styled.div`
  align-items: flex-start;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-start;
  margin-top: 50px;
  width: 100%;
  ${({ theme }) => {
    return (
      theme &&
      css`
        @media (max-width: ${theme.breakpoints.medium}) {
          width: calc(100% + 10px);
          margin: -5px;
          margin-top: 20px;
        }
      `
    );
  }}
  li {
    background: transparent;
    height: auto;
    padding: 20px;
    width: calc(50% - 20px);
    ${({ theme }) => {
      return (
        theme &&
        css`
          @media (max-width: ${theme.breakpoints.medium}) {
            width: 100%;
          }
        `
      );
    }}
    a {
      text-decoration: none;
      color: currentColor;
      > div {
        position: static !important;
      }
    }
    img{
      height: 75px !important;
      left: 0 !important;
      position: relative;
      top: 10% !important
      width: 75px !important;
    }
    strong{
      display: block;
      margin-bottom: 20px;
      margin-top: 30px;
    }
    span{
      cursor: pointer;
      display: inline-block;
      font-size: 16px;
      font-weight: 600;
      margin-top: 20px;
      position: relative;
      &::after {
        background: #364ef7;
        bottom: -4px;
        content: '';
        height: 2px;
        left: 0;
        position: absolute;
        transform: scaleX(0);
        transition: 300ms;
        width: 100%;
      }
      &:hover,
      &.active {
        &:after {
          transform: scaleX(1);
        }
      }
    }
  }
`;

export const Container = styled.div`
  align-items: center;
  box-sizing: border-box;
  justify-content: space-between;
  margin: 0 auto;
  max-width: 1440px;
  padding: 0 80px;
  ${({ theme }) => {
    return (
      theme &&
      css`
        @media (max-width: ${theme.breakpoints.medium}) {
          padding: 0 16px;
          flex-direction: column;
        }
      `
    );
  }}
`;
